module.exports = __webpack_public_path__ + "static/media/table-blue.f39506a6.svg";